import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { boot } from './boot';
import './styles/base.css';
import './styles/table.css';
import './styles/dialogs.css';
import './styles/portal.css';
import './styles/rooms.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void boot();
